import { render, staticRenderFns } from "./EntityCounts.vue?vue&type=template&id=45b8ae7f"
import script from "./EntityCounts.vue?vue&type=script&lang=js"
export * from "./EntityCounts.vue?vue&type=script&lang=js"
import style0 from "./EntityCounts.vue?vue&type=style&index=0&id=45b8ae7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports